import type { ImageType } from '@/core/features/image-v2/image-type';

import * as React from 'react';

import { ResponsiveImage } from '@/core/features';

type BannerProps = React.PropsWithChildren & {
    className?: string;
    height: number;
    image: ImageType | null;
    imageOverlayColor?: string;
    marginBottom?: number;
};

export default function Banner({
    children,
    className,
    height,
    image,
    imageOverlayColor,
    marginBottom = 0,
}: BannerProps) {
    return (
        <div
            className={'flex w-full'}
            style={{
                height,
                marginBottom,
            }}
        >
            {image && (
                <div className={'absolute top-0 left-0 right-0'}>
                    <ResponsiveImage
                        alt={image.imageAlt}
                        fetchPriority={'high'}
                        height={height}
                        layoutWidth={100}
                        preload={true}
                        url={image.imageUrl}
                    />
                </div>
            )}
            <div
                className={'absolute inset-0'}
                style={{
                    backgroundColor: imageOverlayColor,
                    // eslint-disable-next-line no-inline-styles/no-inline-styles
                    height: 'inherit',
                }}
            />
            <div className={`w-full h-full z-1 ${className ? className : ''}`}>{children}</div>
        </div>
    );
}
